import { render, staticRenderFns } from "./ProjectsItemInfoComponent.vue?vue&type=template&id=62ad3878&scoped=true&"
import script from "./ProjectsItemInfoComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsItemInfoComponent.vue?vue&type=style&index=0&id=62ad3878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad3878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VCombobox,VTextField,VTextarea})
